import { takeEvery, call, put, select } from 'redux-saga/effects'
import { updateTagsObject, UPDATE_NOTIFICATIONS_TAGS, loading, putNotifications, putTags } from '../../store/Notifications/actions'
import { showAlertError } from '../../store/Alert/actions'
import axios from 'axios'

export default function* () {
    yield takeEvery(UPDATE_NOTIFICATIONS_TAGS, worker)
}

function* worker({ payload }) {
    try {
        const tagsInsert = yield call(fetchUpdate, payload)


        if (tagsInsert.error) {
            yield put(showAlertError({
                errors: [`Ошибка сервера при ${UPDATE_NOTIFICATIONS_TAGS}.`, tagsInsert],
                text: "Настройки не были сохранены. Попробуйте перезагрузить страницу."
            }))
        } else {

            yield put(updateTagsObject(payload))
        }
    }
    catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${UPDATE_NOTIFICATIONS_TAGS}.`, e],
            text: "Настройки не были сохранены. Попробуйте перезагрузить страницу."
        }))
    }
    finally {
        yield put(loading(false))
    }
}

function fetchUpdate(data) {
    let formData = new FormData()
    
    formData.set('tags', data.tags);

    
    return axios.post("/push/update?owner_id="+data.owner_id, formData)
        .then(response => response.data)
}

